
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import Switcher from "@/components/UI/Switcher.vue";
import CountrySelect from "@/components/StoreLocator/CountrySelect.vue";
import StoreLocatorResult from "@/components/StoreLocator/StoreLocatorResult.vue";
import { StoreState, SwitcherFilter } from "@/interfaces";
import { useStore } from "vuex";
import {
  faCaretRight,
  faAngleDown,
  faAngleUp,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

export default defineComponent({
  name: "StoreLocatorFilters",
  emits: ["select"],
  components: {
    Switcher,
    CountrySelect,
    StoreLocatorResult,
  },
  setup() {
    const store = useStore<StoreState>();
    const showFilters = ref(true);
    const dirty = ref(false);
    const isMounted = ref(false);

    const switchFilters = ref<SwitcherFilter[]>([
      {
        label: "Tutti",
        value: null,
        pointer: false,
      },
      {
        label: "Punti vendita",
        value: false,
        pointer: false,
      },
      {
        label: "Store",
        value: true,
        pointer: true,
      },
    ]);

    onMounted(async () => {
      if (navigator.geolocation && store.getters.hasGeolocation) {
        store.commit('setLoading', true);
        navigator.geolocation.getCurrentPosition(
            async (pos: any) => {
              await setCurrentLocation(pos);
              await store.dispatch("getStoreLocators");
              dirty.value = true;
            },
            () => {
              store.commit('setLoading', false);
            }
        );
      }

      isMounted.value = true;
    });

    const onToggleFilters = () => {
      showFilters.value = !showFilters.value;
    };

    const onChangeFilter = (el: SwitcherFilter) => {
      store.commit("setFilters", {
        franchising: el.value,
      });
    };

    const onChangeCountry = (countryFilter: any) => {
      store.commit("setFilters", countryFilter);
    };

    const franchising = computed<SwitcherFilter>(() => {
      return {
        label: "",
        value: store.state.filters.franchising,
        pointer: true,
      };
    });

    const numberResultText = computed(() => {
      if (store.state.countStoreLocators === 0) {
        return "Nessun risultato trovato";
      }
      return (
        "Abbiamo trovato " + store.state.countStoreLocators + " rivenditori"
      );
    });

    const isLoading = computed(() => {
      return store.state.isLoading;
    });

    const setCurrentLocation = async (position: GeolocationPosition) => {
      store.commit("setFilters", {
        coordinates: position.coords.latitude + "," + position.coords.longitude,
      });
    };

    const onFindStoreLocators = async () => {
      dirty.value = true;
      await store.dispatch("getStoreLocators");
      showFilters.value = false;
    };



    return {
      onToggleFilters,
      onChangeFilter,
      onChangeCountry,
      onFindStoreLocators,
      dirty,
      showFilters,
      switchFilters,
      franchising,
      isMounted,
      isLoading,
      FaCaretRight: faCaretRight,
      FaAngleDown: faAngleDown,
      FaAngleUp: faAngleUp,
      FaSpinner: faSpinner,
      numberResultText,
    };
  },
});
